import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinkharadi() {



  const cardData =
  {
    keyword: 'Corporate Cab Service in Kharadi',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Kharadi',
    headingDescription: ' Pune Corporate Cars India Private Limited offers premium Corporate Cab Service in Kharadi, providing businesses, IT companies, and corporate offices with smooth, reliable, and professional travel solutions. With a fleet of executive sedans, SUVs, and luxury cars, we ensure comfortable daily employee transportation, client pickups, airport transfers, and VIP travel. Kharadi being a major IT and corporate hub, our services are designed for punctuality, safety, and efficiency, meeting the fast-paced demands of modern businesses. Whether you need dedicated office cabs, on-demand corporate rentals, or chauffeur-driven cars for meetings, Pune Corporate Cars India Private Limited guarantees a seamless, safe, and high-quality travel experience for all your corporate mobility needs.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



  "services": [
  {
    "name": "Kharadi IT Park Cab Service",
    "description": "Kharadi IT Park Cab Service offers fast, reliable, and professional transportation for employees, managers, and executives working in the Kharadi tech hub. With dedicated routes, punctual pickups, and experienced chauffeurs, we ensure smooth travel during peak hours and shift timings. Our fleet includes sedans, SUVs, and hatchbacks maintained to high standards. Designed for IT companies and corporate teams, Kharadi IT Park Cab Service ensures convenience, safety, and efficient mobility every day."
  },
  {
    "name": "EON IT Park Corporate Cab",
    "description": "EON IT Park Corporate Cab provides premium and well-coordinated transportation solutions for businesses operating inside EON Tech Park. We offer dedicated cabs, route optimization, and professional chauffeurs trained for corporate environments. The service covers daily travel, executive movement, client transfers, and inter-office visits. With flexible plans and clean, well-maintained vehicles, EON IT Park Corporate Cab guarantees professional-grade mobility for companies in the tech park."
  },
  {
    "name": "Kharadi Employee Transportation",
    "description": "Kharadi Employee Transportation ensures timely, safe, and comfortable daily commute for staff working in and around Kharadi. Designed for IT companies, corporate offices, and tech parks, our service includes multi-route planning, verified drivers, GPS-enabled vehicles, and shift-based scheduling. Employees travel comfortably in AC vehicles with secure and consistent pickup–drop service. Kharadi Employee Transportation improves productivity, reduces travel stress, and ensures reliable workforce mobility."
  },
  {
    "name": "Kharadi Office Pickup & Drop",
    "description": "Kharadi Office Pickup & Drop provides dependable and well-managed daily commuting solutions for companies located in Kharadi’s IT and commercial zones. Our service includes structured pickup and drop timings, clean vehicles, professional chauffeurs, and real-time tracking for added safety. Ideal for teams working regular and rotational shifts, Kharadi Office Pickup & Drop ensures smooth and punctual office travel every day."
  },
  {
    "name": "Kharadi Business Taxi Service",
    "description": "Kharadi Business Taxi Service offers premium taxi solutions for executives, managers, and business travelers. The service supports meetings, office visits, airport transfers, and intercity business travel. With comfortable interiors, AC, disciplined drivers, and seamless booking, we ensure a professional travel experience. Kharadi Business Taxi Service is ideal for companies seeking reliable and high-quality mobility in the corporate district."
  },
  {
    "name": "Kharadi Corporate Shuttle",
    "description": "Kharadi Corporate Shuttle provides group transportation for employees commuting to major tech parks such as EON IT Park, World Trade Center, and Zensar. Our shuttles include spacious AC vans, minibuses, and tempo travellers equipped for safe and comfortable travel. We manage multi-route operations, schedule planning, and consistent daily services. Kharadi Corporate Shuttle is perfect for large organizations needing efficient workforce mobility."
  },
  {
    "name": "EON Tech Park Staff Cab",
    "description": "EON Tech Park Staff Cab delivers reliable and structured transportation solutions specifically for employees of EON Tech Park. We offer fixed routes, shift-based cabs, night shift safety protocols, and GPS-enabled vehicles. Each cab is clean, air-conditioned, and operated by trained drivers ensuring punctual and safe office travel. EON Tech Park Staff Cab supports companies in maintaining smooth and uninterrupted workforce movement."
  },
  {
    "name": "Corporate Fleet Provider Kharadi",
    "description": "Corporate Fleet Provider Kharadi offers businesses fully managed fleets including sedans, SUVs, vans, and tempo travellers. Designed for IT companies and commercial offices, this service provides dedicated vehicles, professional chauffeurs, maintenance support, and quick replacements. Companies benefit from centralized billing, scalable fleet options, and seamless transportation coordination. Corporate Fleet Provider Kharadi ensures efficient and worry-free corporate mobility."
  },
  {
    "name": "Best Corporate Cabs Kharadi",
    "description": "Best Corporate Cabs Kharadi provides top-rated professional transportation for companies needing reliable office commute, executive travel, and staff movement. Known for punctuality, trained chauffeurs, and clean, AC-equipped vehicles, our service is ideal for startups, IT firms, and large enterprises. We offer daily travel, monthly rentals, and on-demand cab services. Best Corporate Cabs Kharadi ensures safe, comfortable, and consistent mobility within the Kharadi business district."
  },
  {
    "name": "Affordable Office Cabs Kharadi",
    "description": "Affordable Office Cabs Kharadi offers cost-effective and dependable cab solutions for companies looking to optimize transportation budgets. Despite being budget-friendly, vehicles are well-maintained, fully sanitized, and equipped with AC for a comfortable ride. Our service covers daily pickups, drops, and inter-office travel with transparent pricing and timely service. Affordable Office Cabs Kharadi is perfect for startups and growing businesses in Kharadi."
  },
  {
    "name": "Kharadi Corporate Sedan Cabs",
    "description": "Kharadi Corporate Sedan Cabs offers stylish and comfortable sedans ideal for executives, managers, and client travel. Vehicles such as Dzire, Etios, and Honda City ensure smooth, premium, and safe travel experiences. Chauffeurs are trained in corporate etiquette and punctuality. Perfect for meetings, airport transfers, and official visits, Kharadi Corporate Sedan Cabs provides a high-standard travel experience for businesses operating in Kharadi."
  },
  {
    "name": "Kharadi Airport Transfer Corporate",
    "description": "Kharadi Airport Transfer Corporate provides fast, safe, and punctual airport travel for business professionals. Our chauffeurs track flight timings to ensure timely pickups and drop-offs. Cars feature AC, clean interiors, comfortable seating, and smooth suspension for executive-level comfort. Ideal for incoming clients, CEOs, and frequent flyers, Kharadi Airport Transfer Corporate ensures seamless and stress-free airport connectivity."
  },
  {
    "name": "Outstation Corporate Cab Kharadi",
    "description": "Outstation Corporate Cab Kharadi offers reliable intercity travel for businesses requiring long-distance mobility. Whether it's Pune–Mumbai, Pune–Nashik, Pune–Kolhapur, or other outstation routes, our sedans and SUVs provide comfort and safety throughout the journey. Chauffeurs are experienced in highway driving and ensure timely arrivals. Outstation Corporate Cab Kharadi is ideal for corporate meetings, site visits, and business tours."
  },
  {
    "name": "Monthly Corporate Cabs Kharadi",
    "description": "Monthly Corporate Cabs Kharadi provides long-term cab services ideal for companies managing daily employee movement and executive travel. Vehicles are assigned on a monthly contract with dedicated chauffeurs, predictable billing, and priority replacements. Each car is sanitized, maintained, and monitored to ensure uninterrupted mobility. Monthly Corporate Cabs Kharadi offers economical and dependable transportation for businesses in the Kharadi region."
  },
  {
    "name": "Corporate Chauffeur Service Kharadi",
    "description": "Corporate Chauffeur Service Kharadi provides premium chauffeur-driven cars for executives, CEOs, clients, and VIP corporate guests. Our chauffeurs are trained in etiquette, confidentiality, and defensive driving. Vehicles include luxury sedans and high-comfort models with plush interiors and professional standards. Ideal for meetings, airport transfers, and business events, Corporate Chauffeur Service Kharadi ensures a sophisticated and high-quality travel experience."
  }
],
"tableData": [
  ["Kharadi IT Park Cab Service", "EON IT Park Corporate Cab"],
  ["Kharadi Employee Transportation", "Kharadi Office Pickup & Drop"],
  ["Kharadi Business Taxi Service", "Kharadi Corporate Shuttle"],
  ["EON Tech Park Staff Cab", "Corporate Fleet Provider Kharadi"],
  ["Best Corporate Cabs Kharadi", "Affordable Office Cabs Kharadi"],
  ["Kharadi Corporate Sedan Cabs", "Kharadi Airport Transfer Corporate"],
  ["Outstation Corporate Cab Kharadi", "Monthly Corporate Cabs Kharadi"],
  ["Corporate Chauffeur Service Kharadi", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Kharadi",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and premium corporate cab services in Kharadi, ensuring smooth and professional travel for employees and business executives."
  },
  {
    "WhyChooseheading": "Ideal for IT & Corporate Hubs",
    "WhyChoosedescription": "Our services are tailored for companies in Kharadi’s major IT parks, offering punctual and seamless transportation for daily office commute."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "All our cabs are well-maintained, sanitized, and equipped to deliver a comfortable and safe ride for corporate passengers."
  },
  {
    "WhyChooseheading": "Transparent Corporate Pricing",
    "WhyChoosedescription": "We offer clear and competitive pricing with no hidden charges, suitable for both small teams and large corporate travel needs."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from daily, weekly, or monthly travel plans designed to match office timings and corporate requirements in Kharadi."
  },
  {
    "WhyChooseheading": "Professional & Trained Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers ensure punctual pickups, safe driving, and a smooth commuting experience every day."
  },
  {
    "WhyChooseheading": "24/7 Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, emergency travel needs, and schedule changes."
  },
  {
    "WhyChooseheading": "Quick & Hassle-Free Booking",
    "WhyChoosedescription": "Book your corporate cab for Kharadi easily through our online portal or by phone, with fast confirmations and reliable service."
  }
]




















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services in Kharadi?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services in Kharadi for office commute, business meetings, and client transportation.',
  },
  {
    question: 'How can I book a corporate cab in Kharadi with Pune Corporate Cars India Private Limited?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Kharadi?',
    answer: 'We offer hatchbacks, sedans, SUVs, and luxury cars to meet various corporate travel requirements in Kharadi.',
  },
  {
    question: 'Are drivers trained for corporate travel in Kharadi?',
    answer: 'Yes, our drivers are professional, well-trained, punctual, and experienced in handling corporate transportation needs.',
  },
  {
    question: 'Do you provide daily, weekly, or monthly corporate cab services in Kharadi?',
    answer: 'Absolutely. We offer flexible corporate cab packages including daily, weekly, and monthly plans for companies in Kharadi.',
  },
  {
    question: 'Is the corporate cab service available 24×7 in Kharadi?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers 24×7 availability for corporate cab services to match your business schedules.',
  },
  {
    question: 'What safety measures are followed in corporate cabs in Kharadi?',
    answer: 'All cabs are sanitized regularly, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are available for corporate cab services in Kharadi?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate billing.',
  },
  {
    question: 'Is customer support available during the corporate cab service period?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you anytime during your service.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya More',
    feedback: 'Excellent corporate cab service in Kharadi. The car was clean, and the driver was extremely professional. Highly reliable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rutuja Patankar',
    feedback: 'Our company uses Pune Corporate Cars India Private Limited regularly in Kharadi. Always punctual and dependable. Strongly recommended!',
    rating: 5,
  },
];









































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Kharadi",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-kharadi.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Kharadi, Pune, providing employee transportation, office pickup and drop, IT park shuttle services, and business travel cabs. Pune Corporate Cars India Private Limited ensures safe and comfortable rides for companies in Kharadi and nearby areas.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4700", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-kharadi"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Kharadi | Employee & Office Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Kharadi, Pune, offering employee transportation, office pickup and drop, IT park shuttle services, and business travel cabs. Pune Corporate Cars India Private Limited provides safe and comfortable rides for Kharadi offices."
  />

  <meta
    name="keywords"
    content="Kharadi IT Park Cab Service, EON IT Park Corporate Cab, Kharadi Employee Transportation, Kharadi Office Pickup & Drop, Kharadi Business Taxi Service, Kharadi Corporate Shuttle, EON Tech Park Staff Cab, Corporate Fleet Provider Kharadi, Best Corporate Cabs Kharadi, Affordable Office Cabs Kharadi, Kharadi Corporate Sedan Cabs, Kharadi Airport Transfer Corporate, Outstation Corporate Cab Kharadi, Monthly Corporate Cabs Kharadi, Corporate Chauffeur Service Kharadi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinkharadi;